const API = {
  API_BASE_URL: 'https://pluraldevpoc.pinepg.in',
  API_AUTH_URL: 'https://pluraldevpoc.pinepg.in',
  SETTLEMENT_API_BASE_URL: 'http://65.0.222.46:9000',
  SETTLEMENT_API_AUTH_URL: 'http://65.0.222.46:9000',
};

export default {
  API,
};
